import { MediaElement, VideoParam, VideoSettings, youtubeJsApiAttribute } from './typing';

export const getVideoSettings = (
	element: MediaElement,
	isVideoElement: boolean,
	isVideoIframeElement: boolean,
	defaultSrc?: string
): VideoSettings | undefined => {
	if (isVideoElement) {
		return {
			[VideoParam.autoplay]: element.getAttribute(VideoParam.autoplay) != null,
			[VideoParam.controls]: element.getAttribute(VideoParam.controls) != null,
			[VideoParam.muted]: element.getAttribute(VideoParam.muted) != null,
		};
	} else if (isVideoIframeElement) {
		const defaultSettings = {
			[VideoParam.autoplay]: false,
			[VideoParam.controls]: true,
			[VideoParam.muted]: false,
		};
		const src = defaultSrc || element.src; // src can be empty when iframe is hidden
		const attributesString = src.split('?')[1];

		if (!attributesString) {
			return defaultSettings;
		}

		return attributesString.split('&').reduce((acc, current) => {
			const [name, value] = current.split('=');

			if (name !== youtubeJsApiAttribute) {
				const attributeName = name === 'mute' ? VideoParam.muted : name;
				acc[attributeName] = value !== '0';
			}

			return acc;
		}, defaultSettings);
	}

	return;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableMedia/getData.ts